export const ExternalRoutes = [
  {
    path: "/ext/sessions/create",
    name: "extSessionCreate",
    component: () => import("../pages/CreateSessionURLPage.vue"),
    meta: { requiresAuth: false },
  },
];
